import { APP_STORE_URLS } from "shared/config/appStoreUrls";
import { isAdvancedbrVisit } from "shared/utils/campaignVisit";

export type AppStore = "ios" | "android";

type AppDownloadHandler = (store: AppStore) => void;

/**
 * Handler do `AppDownloadGate` (montado uma vez no `App`). Fica fora do React
 * porque o rodapé chama o download a partir de configuração, sem componente.
 */
let currentHandler: AppDownloadHandler | null = null;

export function openStore(store: AppStore): void {
  window.open(APP_STORE_URLS[store], "_blank", "noreferrer");
}

/**
 * Ponto único dos botões de download do app. Fora da campanha da AdvancedBR,
 * ou sem o gate montado, abre a loja direto, como sempre foi.
 */
export function requestAppDownload(store: AppStore): void {
  if (!currentHandler || !isAdvancedbrVisit()) {
    openStore(store);
    return;
  }

  currentHandler(store);
}

export function registerAppDownloadHandler(
  handler: AppDownloadHandler,
): () => void {
  currentHandler = handler;

  return () => {
    if (currentHandler === handler) currentHandler = null;
  };
}
